/**
 * @fileoverview Status data source and type definitions.
 */

import { StatusSchema, type Status } from '@schema/index';
import { createBaseDataSource } from './base-data-source';
import { createAccountTrackingFields, createCreatedAtField, createDeletedAtField, createIdField, createJsonField, createNameField, createNumberField, createSelectField, createStringField, createUpdatedAtField, FIELD_TYPE_WIDTHS, FIELD_WIDTHS } from './field-factories';
import { getCache } from './cache-registry';

export type { Status };

/** Status category options for dropdown. */
const STATUS_CATEGORY_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'indeterminate', label: 'Indeterminate' },
  { value: 'done', label: 'Done' },
] as const;

export const statusDataSource = createBaseDataSource<Status>({
  endpoint: 'status',
  searchField: 'name',
  schema: StatusSchema,
  fields: [
    createIdField(FIELD_WIDTHS.SMALL),
    createNameField(FIELD_TYPE_WIDTHS.NAME),
    createStringField('description', 'Description', FIELD_WIDTHS.XLARGE),
    createSelectField('status_category', 'Category', [...STATUS_CATEGORY_OPTIONS], FIELD_WIDTHS.MEDIUM),
    createNumberField('display_order', 'Display Order', FIELD_WIDTHS.SMALL),
    createJsonField('metadata', 'Metadata', FIELD_WIDTHS.XLARGE),
    ...createAccountTrackingFields(),
    createCreatedAtField(),
    createUpdatedAtField(),
    createDeletedAtField(),
  ],
});

export const statusCache = getCache('status');
